import React, { useEffect, useState } from 'react'
import { procesosPorFuncionario } from '../../utils/Datos'
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { Header, Table, Rating } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom';
import { Modal } from "../Otros/Modal";
import { VerEvaluacionesPrecalificacionesFuncionario } from './VerEvaluacionesPrecalificacionesFuncionario';


export const CalificacionesFuncionario = () => {
    const user = useSelector(selectUser);
    const [procesos, setprocesos] = useState(null);
    const [procesoActual, setprocesoActual] = useState(null);


    useEffect(() => {
      if (user!=null) {
        procesosPorFuncionario(user.user.id_officer).then((data)=>{
            setprocesos(data);
        })
      }
      
    }, [user])

   
    return (
            <>
                {
                    procesos===null ? 
                    <>
                        <div className="alert alert-info" role="alert">
                            <strong>No tienes procesos asociados</strong>
                        </div>
                    </>
                    :
                    <>
                        <h3>Tus procesos</h3>
                        <table className='table table-rounded table-striped border gy-7 gs-7'>
                            <thead>
                                <tr>
                                    <th>Nombre del Proceso</th>
                                    <th>Dirección Municipal</th>
                                    <th>Unidad Municipal</th>
                                    <th>Precalificador</th>
                                    
                                    <th>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    procesos.map((dato,index)=>{
                                        return  <tr>
                                                   <td>
                                                        {dato.nameProcess}
                                                    </td>
                                                    <td>
                                                        {dato.nameDmunicipal}
                                                    </td>
                                                    <td>
                                                        {dato.nameUmunicipal}
                                                    </td>
                                                    <td>
                                                        {dato.namePrequalifier}
                                                    </td>
                                                  
                                                    <td>
                                                        <NavLink 
                                                        className="btn btn-primary btn-sm"
                                                        to={'/detallePrecalificaciones/'+dato.id_participant}
                                                        >
                                                            Ver Detalle
                                                        </NavLink>
                                                    </td>
                                                </tr>
                                    })
                                }
                                
                            </tbody>
                        </table>
                    </>
                }

            </>
        )
    
}
